import { Stack, useTheme } from "@mui/material";
import formatNumber from "../../../_utils/formatNumber";
import { Bot } from "../../../_app/types";
import Text from "../../../_components/Text";
import { useTranslation } from "react-i18next";

interface Props {
  bot: Bot;
  orderStep: number;
}

const GridSettings = ({ bot, orderStep }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation("botsList");

  return (
    <Stack direction={"row"} gap="4px">
      <Text variant="s-semi">{`${bot.gridsAmount}`}</Text>
      <Text variant="s" color={theme.myTheme.colors.foreground50}>
        {t("gridsWithStep", { count: bot.gridsAmount })}
      </Text>
      <Text variant="s-semi">
        {`${formatNumber(bot.gridType === "ARITHMETIC" ? bot.priceStep : bot.priceStep * 100, orderStep)} `}
      </Text>

      <Text variant="s" color={theme.myTheme.colors.foreground50}>
        {bot.gridType === "ARITHMETIC" ? bot.quote : "%"}
      </Text>
    </Stack>
  );
};

export default GridSettings;
